import { render, staticRenderFns } from "./RunPayrollView.vue?vue&type=template&id=2b4f61e3&"
import script from "./RunPayrollView.vue?vue&type=script&lang=js&"
export * from "./RunPayrollView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports